/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SorryRouteImport } from './routes/sorry'
import { Route as OopsRouteImport } from './routes/oops'
import { Route as HelpRouteImport } from './routes/help'
import { Route as Hci_shortnameRouteRouteImport } from './routes/$hci_shortname/route'
import { Route as Hci_shortnameIndexRouteImport } from './routes/$hci_shortname/index'
import { Route as Hci_shortnameVerificationRouteImport } from './routes/$hci_shortname/verification'
import { Route as Hci_shortnameThankYouRouteImport } from './routes/$hci_shortname/thank-you'
import { Route as Hci_shortnamePersonalDetailsRouteImport } from './routes/$hci_shortname/personal-details'
import { Route as Hci_shortnameContactDetailsRouteImport } from './routes/$hci_shortname/contact-details'
import { Route as Hci_shortnameSplatRouteImport } from './routes/$hci_shortname/$'

const SorryRoute = SorryRouteImport.update({
  id: '/sorry',
  path: '/sorry',
  getParentRoute: () => rootRouteImport,
} as any)
const OopsRoute = OopsRouteImport.update({
  id: '/oops',
  path: '/oops',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const Hci_shortnameRouteRoute = Hci_shortnameRouteRouteImport.update({
  id: '/$hci_shortname',
  path: '/$hci_shortname',
  getParentRoute: () => rootRouteImport,
} as any)
const Hci_shortnameIndexRoute = Hci_shortnameIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Hci_shortnameRouteRoute,
} as any)
const Hci_shortnameVerificationRoute =
  Hci_shortnameVerificationRouteImport.update({
    id: '/verification',
    path: '/verification',
    getParentRoute: () => Hci_shortnameRouteRoute,
  } as any)
const Hci_shortnameThankYouRoute = Hci_shortnameThankYouRouteImport.update({
  id: '/thank-you',
  path: '/thank-you',
  getParentRoute: () => Hci_shortnameRouteRoute,
} as any)
const Hci_shortnamePersonalDetailsRoute =
  Hci_shortnamePersonalDetailsRouteImport.update({
    id: '/personal-details',
    path: '/personal-details',
    getParentRoute: () => Hci_shortnameRouteRoute,
  } as any)
const Hci_shortnameContactDetailsRoute =
  Hci_shortnameContactDetailsRouteImport.update({
    id: '/contact-details',
    path: '/contact-details',
    getParentRoute: () => Hci_shortnameRouteRoute,
  } as any)
const Hci_shortnameSplatRoute = Hci_shortnameSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => Hci_shortnameRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/$hci_shortname': typeof Hci_shortnameRouteRouteWithChildren
  '/help': typeof HelpRoute
  '/oops': typeof OopsRoute
  '/sorry': typeof SorryRoute
  '/$hci_shortname/$': typeof Hci_shortnameSplatRoute
  '/$hci_shortname/contact-details': typeof Hci_shortnameContactDetailsRoute
  '/$hci_shortname/personal-details': typeof Hci_shortnamePersonalDetailsRoute
  '/$hci_shortname/thank-you': typeof Hci_shortnameThankYouRoute
  '/$hci_shortname/verification': typeof Hci_shortnameVerificationRoute
  '/$hci_shortname/': typeof Hci_shortnameIndexRoute
}
export interface FileRoutesByTo {
  '/help': typeof HelpRoute
  '/oops': typeof OopsRoute
  '/sorry': typeof SorryRoute
  '/$hci_shortname/$': typeof Hci_shortnameSplatRoute
  '/$hci_shortname/contact-details': typeof Hci_shortnameContactDetailsRoute
  '/$hci_shortname/personal-details': typeof Hci_shortnamePersonalDetailsRoute
  '/$hci_shortname/thank-you': typeof Hci_shortnameThankYouRoute
  '/$hci_shortname/verification': typeof Hci_shortnameVerificationRoute
  '/$hci_shortname': typeof Hci_shortnameIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$hci_shortname': typeof Hci_shortnameRouteRouteWithChildren
  '/help': typeof HelpRoute
  '/oops': typeof OopsRoute
  '/sorry': typeof SorryRoute
  '/$hci_shortname/$': typeof Hci_shortnameSplatRoute
  '/$hci_shortname/contact-details': typeof Hci_shortnameContactDetailsRoute
  '/$hci_shortname/personal-details': typeof Hci_shortnamePersonalDetailsRoute
  '/$hci_shortname/thank-you': typeof Hci_shortnameThankYouRoute
  '/$hci_shortname/verification': typeof Hci_shortnameVerificationRoute
  '/$hci_shortname/': typeof Hci_shortnameIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$hci_shortname'
    | '/help'
    | '/oops'
    | '/sorry'
    | '/$hci_shortname/$'
    | '/$hci_shortname/contact-details'
    | '/$hci_shortname/personal-details'
    | '/$hci_shortname/thank-you'
    | '/$hci_shortname/verification'
    | '/$hci_shortname/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/help'
    | '/oops'
    | '/sorry'
    | '/$hci_shortname/$'
    | '/$hci_shortname/contact-details'
    | '/$hci_shortname/personal-details'
    | '/$hci_shortname/thank-you'
    | '/$hci_shortname/verification'
    | '/$hci_shortname'
  id:
    | '__root__'
    | '/$hci_shortname'
    | '/help'
    | '/oops'
    | '/sorry'
    | '/$hci_shortname/$'
    | '/$hci_shortname/contact-details'
    | '/$hci_shortname/personal-details'
    | '/$hci_shortname/thank-you'
    | '/$hci_shortname/verification'
    | '/$hci_shortname/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  Hci_shortnameRouteRoute: typeof Hci_shortnameRouteRouteWithChildren
  HelpRoute: typeof HelpRoute
  OopsRoute: typeof OopsRoute
  SorryRoute: typeof SorryRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sorry': {
      id: '/sorry'
      path: '/sorry'
      fullPath: '/sorry'
      preLoaderRoute: typeof SorryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oops': {
      id: '/oops'
      path: '/oops'
      fullPath: '/oops'
      preLoaderRoute: typeof OopsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$hci_shortname': {
      id: '/$hci_shortname'
      path: '/$hci_shortname'
      fullPath: '/$hci_shortname'
      preLoaderRoute: typeof Hci_shortnameRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$hci_shortname/': {
      id: '/$hci_shortname/'
      path: '/'
      fullPath: '/$hci_shortname/'
      preLoaderRoute: typeof Hci_shortnameIndexRouteImport
      parentRoute: typeof Hci_shortnameRouteRoute
    }
    '/$hci_shortname/verification': {
      id: '/$hci_shortname/verification'
      path: '/verification'
      fullPath: '/$hci_shortname/verification'
      preLoaderRoute: typeof Hci_shortnameVerificationRouteImport
      parentRoute: typeof Hci_shortnameRouteRoute
    }
    '/$hci_shortname/thank-you': {
      id: '/$hci_shortname/thank-you'
      path: '/thank-you'
      fullPath: '/$hci_shortname/thank-you'
      preLoaderRoute: typeof Hci_shortnameThankYouRouteImport
      parentRoute: typeof Hci_shortnameRouteRoute
    }
    '/$hci_shortname/personal-details': {
      id: '/$hci_shortname/personal-details'
      path: '/personal-details'
      fullPath: '/$hci_shortname/personal-details'
      preLoaderRoute: typeof Hci_shortnamePersonalDetailsRouteImport
      parentRoute: typeof Hci_shortnameRouteRoute
    }
    '/$hci_shortname/contact-details': {
      id: '/$hci_shortname/contact-details'
      path: '/contact-details'
      fullPath: '/$hci_shortname/contact-details'
      preLoaderRoute: typeof Hci_shortnameContactDetailsRouteImport
      parentRoute: typeof Hci_shortnameRouteRoute
    }
    '/$hci_shortname/$': {
      id: '/$hci_shortname/$'
      path: '/$'
      fullPath: '/$hci_shortname/$'
      preLoaderRoute: typeof Hci_shortnameSplatRouteImport
      parentRoute: typeof Hci_shortnameRouteRoute
    }
  }
}

interface Hci_shortnameRouteRouteChildren {
  Hci_shortnameSplatRoute: typeof Hci_shortnameSplatRoute
  Hci_shortnameContactDetailsRoute: typeof Hci_shortnameContactDetailsRoute
  Hci_shortnamePersonalDetailsRoute: typeof Hci_shortnamePersonalDetailsRoute
  Hci_shortnameThankYouRoute: typeof Hci_shortnameThankYouRoute
  Hci_shortnameVerificationRoute: typeof Hci_shortnameVerificationRoute
  Hci_shortnameIndexRoute: typeof Hci_shortnameIndexRoute
}

const Hci_shortnameRouteRouteChildren: Hci_shortnameRouteRouteChildren = {
  Hci_shortnameSplatRoute: Hci_shortnameSplatRoute,
  Hci_shortnameContactDetailsRoute: Hci_shortnameContactDetailsRoute,
  Hci_shortnamePersonalDetailsRoute: Hci_shortnamePersonalDetailsRoute,
  Hci_shortnameThankYouRoute: Hci_shortnameThankYouRoute,
  Hci_shortnameVerificationRoute: Hci_shortnameVerificationRoute,
  Hci_shortnameIndexRoute: Hci_shortnameIndexRoute,
}

const Hci_shortnameRouteRouteWithChildren =
  Hci_shortnameRouteRoute._addFileChildren(Hci_shortnameRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  Hci_shortnameRouteRoute: Hci_shortnameRouteRouteWithChildren,
  HelpRoute: HelpRoute,
  OopsRoute: OopsRoute,
  SorryRoute: SorryRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
